import keyMirror from 'keymirror';

export const WalkInTypes = keyMirror({
  EXPECTED: null,
  QUOTED: null,
});
